import React, { useState } from 'react';
import DataTable from 'react-data-table-component';

const dummyData = Array.from({ length: 57 }, (_, index) => ({
    id: index + 1,
    name: `Employee ${index + 1}`,
    position: index % 2 === 0 ? 'Developer' : 'Designer',
    office: ['New York', 'Tokyo', 'San Francisco', 'London'][index % 4],
    age: Math.floor(Math.random() * (60 - 20 + 1)) + 20,
    startDate: `202${index % 4}-0${(index % 12) + 1}-0${(index % 28) + 1}`,
}));

const columns = [
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Position', selector: row => row.position, sortable: true },
    { name: 'Office', selector: row => row.office, sortable: true },
    { name: 'Age', selector: row => row.age, sortable: true },
    { name: 'Start Date', selector: row => row.startDate, sortable: true },
];

const customStyles = {
    header: {
        
    },
    headRow: {
        style: {
            backgroundColor: '#6C63FF',
            color: '#ffffff',
            fontWeight: 'bold',
            fontSize: '16px',
        },
    },
    rows: {
        style: {
            backgroundColor: '#F4F6F8',
            '&:nth-of-type(odd)': {
                backgroundColor: '#E8F0FE',
            },
            '&:hover': {
                backgroundColor: '#CCE5FF',
                transition: 'background-color 0.2s ease',
            },
        },
    },
    cells: {
        style: {
            color: '#333333',
            fontSize: '14px',
        },
    },
    pagination: {
        style: {
            backgroundColor: '#F9FAFB',
            borderTop: '1px solid #ddd',
            padding: '10px',
        },
    },
};

const PaginatedTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    // Calculate the data for the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = dummyData.slice(indexOfFirstRow, indexOfLastRow);

    // Pagination Handlers
    const nextPage = () => {
        if (currentPage < Math.ceil(dummyData.length / rowsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const previousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div
            style={{
                padding: '20px',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
        >
            <DataTable
                title="Employee Table"
                columns={columns}
                data={currentRows}
                pagination={false} // Disable built-in pagination
                responsive
                customStyles={customStyles}
                highlightOnHover
            />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '15px',
                }}
            >
                <button
                    onClick={previousPage}
                    disabled={currentPage === 1}
                    style={{
                        padding: '5px 10px',
                        backgroundColor: currentPage === 1 ? '#e0e0e0' : '#4A90E2',
                        color: currentPage === 1 ? '#9e9e9e' : '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        fontWeight: 'bold',
                        fontSize: '10px',
                    }}
                >
                    Previous
                </button>
                <span style={{ alignSelf: 'center', fontWeight: 'bold', fontSize: '10px' }}>
                    Page {currentPage} of {Math.ceil(dummyData.length / rowsPerPage)}
                </span>
                <button
                    onClick={nextPage}
                    disabled={currentPage === Math.ceil(dummyData.length / rowsPerPage)}
                    style={{
                        padding: '5px 10px',
                        backgroundColor:
                            currentPage === Math.ceil(dummyData.length / rowsPerPage)
                                ? '#e0e0e0'
                                : '#4A90E2',
                        color:
                            currentPage === Math.ceil(dummyData.length / rowsPerPage)
                                ? '#9e9e9e'
                                : '#ffffff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor:
                            currentPage === Math.ceil(dummyData.length / rowsPerPage)
                                ? 'not-allowed'
                                : 'pointer',
                        fontWeight: 'bold',
                        fontSize: '10px',
                    }}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default PaginatedTable;
